document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartNote', () => {
    return {
      updating: false,

      // À chaque saisie, on vérifie la longueur et on tranche à 100 si besoin
      onInput() {
        if (this.$root.value.length > 100) {
          this.$root.value = this.$root.value.slice(0, 100);
        }
      },

      updateNote() {
        this.updating = true;
        // On n’envoie que les 100 premiers caractères, pour s’assurer de ne jamais dépasser
        const trimmedNote = this.$root.value.slice(0, 100);

        fetch(theme.routes.cart_update_url, {
          method: 'POST',
          body: JSON.stringify({
            note: trimmedNote,
          }),
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
            Accept: 'application/json',
          },
        }).then(() => {
          this.updating = false;
        });
      },
    };
  });
});
